import { Icon, IconProps } from '../Icon'

export const CalendarIcon = ({ color, size }: IconProps) => {
  return (
    <Icon color={color} size={size}>
      calendar_month
    </Icon>
  )
}
